import { createContext } from 'react';

export interface LayoutContextType {
  hasSidebar: boolean;
  registerSidebar: () => void;
  unregisterSidebar: () => void;
  toggleSidebar: () => void;
  sidebarCollapsed: boolean;
  /** Opt-in UI v2 shell (kirin_ui.html) for the organization view. */
  uiV2: boolean;
  setUiV2: (value: boolean) => void;
}

export const LayoutContext = createContext<LayoutContextType | undefined>(
  undefined
);
